<mat-checkbox
  [(ngModel)]="context.data[context.column.columnDef]"
  (change)="context.cell.actions.onEdited()"
  [disabled]="(!context.data?.copy && !context.data?.includeInPDF) || !context.cell.allowEditing"
></mat-checkbox>
